import { Tag } from '@latitude/tag';
import type { JSX } from 'react';

import type { PeriodToggleProps } from './types';

/**
 * AM/PM period toggle for time selection.
 *
 * Accessibility note: This is semantically a mutually exclusive choice (radio group pattern),
 * but uses toggle buttons (aria-pressed) due to Tag component constraints. The role="group"
 * with aria-label provides adequate accessibility for screen readers. Consider migrating to
 * role="radiogroup" with role="radio" children if Tag component adds support.
 */
export const PeriodToggle = ({
  period,
  onToggle,
  rowHeight,
  daypickerClasses,
}: PeriodToggleProps): JSX.Element => {
  // oxlint-disable-next-line @anchorage/tailwind/no-tailwind-important -- pre-existing fixed-width override on the AM/PM toggles
  const tagClassName = `${rowHeight} -ml-px !w-[40px] cursor-pointer p-0 [&>div]:justify-center`;

  return (
    <div
      className={daypickerClasses.time_picker_row}
      role="group"
      aria-label="Time period"
    >
      <Tag
        className={tagClassName}
        variant="strong"
        fill="outline"
        onClick={onToggle}
        selected={period === 'AM'}
        aria-pressed={period === 'AM'}
        aria-label="AM"
      >
        AM
      </Tag>
      <Tag
        className={tagClassName}
        variant="strong"
        fill="outline"
        onClick={onToggle}
        selected={period === 'PM'}
        aria-pressed={period === 'PM'}
        aria-label="PM"
      >
        PM
      </Tag>
    </div>
  );
};
